import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CreditFilters } from '@repo/position-types'

const initialState = null as CreditFilters | null

export const { actions: positionCreditsFiltersActions, reducer: positionCreditsFiltersReducers } =
  createSlice({
    name: '@position/master/filters/credits',
    initialState: initialState,
    reducers: {
      clearFilter: () => {
        return null
      },
      setFilter: (_, action: PayloadAction<CreditFilters>) => {
        return action.payload
      },
    },
  })
